export default __webpack_public_path__ + "static/media/unpaid.fa329036.svg";